// Exports
export default {
	"content": "content_mwyV8"
};
